import React, { useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Lightbox, LightboxContent, LightboxHeader } from '@fiverr-private/overlay';
import { getWorkSampleTypeByContentType, reportClickEvent, reportHoverEvent } from '../../../utils/workSample';
import { AudioThumbnail, ImageThumbnail, InlineVideoPreview, VideoThumbnail } from './previews';

export function WorkSample({ contentType, url, previewUrl, position, inlineVideoPlayer = false, eventData = {} }) {
    const type = getWorkSampleTypeByContentType(contentType);
    const [isOpen, setIsOpen] = useState(false);

    let preview;

    if (['image', 'pdf'].includes(type)) {
        preview = <ImageThumbnail src={previewUrl} onClick={() => setIsOpen(true)} />;
    } else if (type === 'video' && inlineVideoPlayer) {
        preview = <InlineVideoPreview src={url} poster={previewUrl} contentType={contentType} />;
    } else if (type === 'video') {
        preview = <VideoThumbnail src={previewUrl} onClick={() => setIsOpen(true)} />;
    } else if (type === 'audio') {
        preview = <AudioThumbnail onClick={() => setIsOpen(true)} />;
    } else {
        // Other types are not supported
        return null;
    }

    return (
        <Stack gap={{ default: '1', sm: '3' }} direction="column">
            <Box
                onClick={() => reportClickEvent(eventData, position)}
                onMouseEnter={() => reportHoverEvent(eventData, position)}
            >
                {preview}
            </Box>

            {isOpen && (
                <Lightbox
                    sources={[{ src: url || previewUrl, type }]}
                    onClose={() => setIsOpen(false)}
                    initialSilentMode={false}
                    sourceInitialIndex={0}
                >
                    <LightboxHeader />
                    <LightboxContent />
                </Lightbox>
            )}
        </Stack>
    );
}
